import React from 'react'
import { NavLink } from 'react-router-dom'
import innerBanner from "../assets/images/inner-banner.png";

const Downloads = () => {
  return (
    <>
     <section id="inner-banner-wrapper">
                <div className="banner-image">
                    <img src={innerBanner} alt="Contact Banner" />
                </div>
                <div className="breadcrumb">
                    <h2>Contact</h2>
                    <ul>
                        <li>
                            <NavLink to="/">Home &gt; </NavLink>
                        </li>
                        <li>Downloads</li>
                    </ul>
                </div>
            </section>
    </>
  )
}

export default Downloads